import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Injectable()
class QueryParams {
    constructor(private router: Router)
    {}

    /**
     * Updates queryParams and keeps all existing params in place
     *
     * @param newQueryParams
     * @param activatedRoute
     * @param relativeTo
     */
    public update(newQueryParams, activatedRoute, relativeTo = '/measurements') {
        const subscriber = activatedRoute.queryParams.subscribe((queryParams) => {
            let queryParamsCopy = Object.assign(Object.assign({}, queryParams), newQueryParams);
            this.router.navigate([relativeTo], {
                relativeTo: activatedRoute,
                queryParams: queryParamsCopy
            })
        });
        subscriber.unsubscribe();
    }
}

export default QueryParams;






// WEBPACK FOOTER //
// ./src/app/services/queryParams.service.ts